import React, { useState } from "react";
import { Link } from "react-router-dom";


const mugProducts = [
  {
    id: "m1",
    name: "El Yapımı Kupa 1",
    image: "/images/mug-image-1.png",
    description: "Modern çizgilerle tasarlanmış dekoratif Kupa."
  },
  {
    id: "m2",
    name: "El Yapımı Kupa 2",
    image: "/images/mug-image-2.png",
    description: "Mat yüzeyli, minimalist el yapımı seramik Kupa."
  },
  {
    id: "m3",
    name: "El Yapımı Kupa 3",
    image: "/images/mug-image-3.png",
    description: "Koyu tonlarda, dokulu artistik seramik Kupa."
  },
  {
    id: "v1",
    name: "El Yapımı Vazo 1",
    image: "/images/vase-image-1.png",
    description: "Modern çizgilerle tasarlanmış dekoratif vazo."
  },
  {
    id: "v2",
    name: "El Yapımı Vazo 2",
    image: "/images/vase-image-2.png",
    description: "Mat yüzeyli, minimalist el yapımı seramik vazo."
  },
  {
    id: "v3",
    name: "El Yapımı Vazo 3",
    image: "/images/vase-image-3.png",
    description: "Koyu tonlarda, dokulu artistik seramik vazo."
  }
];

export default function MugSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? mugProducts
    .length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === mugProducts
    .length - 1 ? 0 : prev + 1));
  };

  const getPositionClass = (index) => {
    if (index === currentIndex) return "z-20 scale-100 translate-x-0 opacity-100";
    if (index === (currentIndex + 1) % mugProducts
.length)
      return "z-10 scale-95 translate-x-40 sm:translate-x-48 opacity-95 blur-[2px]";
    if (index === (currentIndex - 1 + mugProducts
    .length) % mugProducts
.length)
      return "z-10 scale-95 -translate-x-40 sm:-translate-x-48 opacity-95 blur-[2px]";
    return "z-0 scale-75 opacity-0 pointer-events-none";
  };
  

  return (
    <div className="relative w-full flex flex-col items-center py-10">
      <h2 className="text-3xl font-bold mb-6">Katalog</h2>
      <div className="relative w-full max-w-6xl overflow-hidden sm:overflow-visible flex items-center justify-center">
        

        <a
onClick={prevSlide}
className="absolute left-0 z-30 p-2 rounded-full shadow backdrop-blur-xl mx-auto w-fit opacity-70 hover:opacity-100 transition "
aria-label="Yana kaydır.">
<svg
  xmlns="http://www.w3.org/2000/svg"
  className="w-6 h-6 text-stone-900"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  strokeWidth={2}
>
  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
</svg>
</a>

<div className="relative w-full flex items-center justify-center h-[360px] sm:h-[400px]">
{mugProducts.map((product, index) => {
  const isActive = index === currentIndex;

  const cardContent = (
    <div className="p-4 rounded-xl shadow-lg bg-white text-center w-[90vw] max-w-[300px] sm:max-w-sm hover:shadow-xl transition">
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-48 sm:h-64 object-contain mx-auto mb-4"
      />
      <h3 className="text-xl font-semibold mb-2">{product.name}</h3>
      <p className="text-gray-600 text-sm sm:text-base">{product.description}</p>
    </div>
  );

  return (
    <div
      key={product.id}
      className={`absolute transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] transform ${getPositionClass(index)}`}
      style={{ transitionProperty: 'all' }}
    >
      {isActive ? (
        <Link to={`/products/${product.id}`}>{cardContent}</Link>
      ) : (
        <div className="pointer-events-none">{cardContent}</div>
      )}
    </div>
  );
})}

</div>

        <a
onClick={nextSlide}
className="absolute right-0 p-2 mx-auto w-fit rounded-full shadow backdrop-blur-xl opacity-70 hover:opacity-100 transition z-30"
aria-label="Yana kaydır.">
<svg
  xmlns="http://www.w3.org/2000/svg"
  className="w-6 h-6 text-stone-900"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  strokeWidth={2}
>
<path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
</svg>
</a>
      </div>
    </div>
  );
}